const mediaItems = [
  {
    title: '繁花',
    subtitle: '王家卫首部电视剧 · 沪上风云',
    tags: ['剧情', '年代', '热播'],
    rating: '9.2',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20Shanghai%20night%20scene%20with%20warm%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%201990s%20nostalgic%20atmosphere%2C%20elegant%20urban%20street%20with%20vintage%20cars%2C%20soft%20golden%20and%20amber%20lighting%2C%20film%20noir%20aesthetic%2C%20dramatic%20cityscape%20with%20deep%20shadows%2C%20no%20people%20no%20text&width=800&height=500&seq=media-card-01&orientation=landscape',
  },
  {
    title: '流浪地球3',
    subtitle: '史诗科幻巨制 · 宇宙征途',
    tags: ['科幻', '冒险', '高分'],
    rating: '8.8',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20massive%20spaceship%20approaching%20a%20glowing%20nebula%2C%20deep%20blue%20and%20teal%20cosmic%20colors%2C%20distant%20stars%20and%20galaxies%2C%20dramatic%20cinematic%20lighting%2C%20futuristic%20technology%20aesthetic%2C%20grand%20scale%20composition%2C%20no%20people%20no%20text&width=800&height=500&seq=media-card-02&orientation=landscape',
  },
  {
    title: '乘风破浪的姐姐',
    subtitle: '全新赛季 · 破浪而来',
    tags: ['综艺', '音乐', '竞演'],
    rating: '8.5',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20setup%20with%20dramatic%20spotlights%20in%20warm%20golden%20and%20rose%20tones%2C%20luxurious%20theater%20curtain%20background%2C%20sparkling%20light%20effects%20floating%20in%20air%2C%20grand%20concert%20hall%20atmosphere%2C%20soft%20bokeh%20background%2C%20entertainment%20show%20vibe%2C%20no%20people%20no%20text&width=800&height=500&seq=media-card-03&orientation=landscape',
  },
  {
    title: '庆余年2',
    subtitle: '权谋大剧续章 · 风云再起',
    tags: ['古装', '权谋', '热播'],
    rating: '9.0',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20misty%20atmosphere%2C%20traditional%20architecture%20with%20red%20lanterns%2C%20soft%20morning%20light%20filtering%20through%20willow%20trees%2C%20elegant%20stone%20pathway%2C%20dramatic%20shadows%20and%20warm%20golden%20light%2C%20historical%20drama%20aesthetic%2C%20no%20people%20no%20text&width=800&height=500&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 max-w-[1400px] mx-auto">
      <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 md:mb-10 gap-3">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">精选推荐</h2>
          <p className="text-sm text-foreground-500">每日精选高分影视，流畅高清在线观看</p>
        </div>
        <span className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          更多推荐 <i className="ri-arrow-right-line"></i>
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {mediaItems.map((item) => (
          <div
            key={item.title}
            className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-full aspect-[16/10] overflow-hidden">
              <img
                src={item.img}
                alt={`爱豆影视推荐 - ${item.title}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-3 right-3 bg-background-50/90 backdrop-blur-sm text-primary-600 text-xs font-bold px-2 py-1 rounded-md">
                {item.rating}
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-base font-semibold text-foreground-950 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2.5">{item.subtitle}</p>
              <div className="flex flex-wrap items-center gap-1.5">
                {item.tags.map((tag) => (
                  <span key={tag} className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}